import {
    StyleSheet
} from "react-native";
import type {
    NavigationMenuCollapsedDynamicStyleType
} from "./type";

const stylesheet = StyleSheet.create({
    root: {
        justifyContent: "space-between",
        flexDirection: "row",
        alignItems: "center",
        minWidth: 0,
        flex: 1
    },
    body: {
        flexDirection: "column"
    },
    title: {
        flexShrink: 1
    }
});

export const useStyles = ({
    spaces
}: NavigationMenuCollapsedDynamicStyleType) => {
    return {
        body: {
            paddingBottom: spaces.spacingSm,
            paddingTop: spaces.spacingXs
        }
    };
};
export default stylesheet;
